package app.nestbridge.feature.children.ui

import app.nestbridge.feature.children.screen.ChildListScreen
import app.nestbridge.feature.children.screen.ChildListState
import com.slack.circuit.runtime.CircuitContext
import com.slack.circuit.runtime.screen.Screen
import com.slack.circuit.runtime.ui.Ui
import com.slack.circuit.runtime.ui.ui
import me.tatarka.inject.annotations.Inject
import software.amazon.lastmile.kotlin.inject.anvil.AppScope
import software.amazon.lastmile.kotlin.inject.anvil.ContributesBinding

@Inject
@ContributesBinding(
  AppScope::class,
  multibinding = true,
)
public class ChildListUiFactory : Ui.Factory {
  override fun create(screen: Screen, context: CircuitContext): Ui<*>? = when (screen) {
    ChildListScreen -> ui<ChildListState> { state, modifier -> ChildListUi(state = state, modifier = modifier) }
    else -> null
  }
}
